import { Button } from '@nimbus-ds/components';
import { InitialScreen } from '@nimbus-ds/patterns';
import { useNavegate } from 'App/hooks';
import useTranslationCatalog from 'domains/Catalog/useTranslationCatalog';
import emptyInventory from './empty-inventory.png';

export function InventoryInitialScreen(): JSX.Element {
  const t = useTranslationCatalog();
  const { goTo } = useNavegate();
  const handleClick = () => goTo('/products');

  const bodyDescription =
    t('inventory.emptyLocation.body.first_paragraph') +
    ' ' +
    t('inventory.emptyLocation.body.second_paragraph');
  return (
    <InitialScreen>
      <InitialScreen.Hero
        subtitle={t('inventory.title').toUpperCase()}
        title={t('inventory.emptyLocation.title')}
        description={bodyDescription}
        image={
          <img
            src={emptyInventory}
            width="100%"
            height="auto"
            alt="empty-products"
          />
        }
        actions={
          <Button as="a" onClick={handleClick} appearance="primary">
            {t('inventory.emptyLocation.action')}
          </Button>
        }
      />
    </InitialScreen>
  );
}
